import { HttpErrorResponse } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BillingService } from '@app/components/billing-approve/billing.service';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UserService } from '@app/services/user/user.service';

@Component({
	selector: 'app-billing-approve',
	templateUrl: './billing-approve.component.html',
	styleUrls: ['./billing-approve.component.scss'],
})
export class BillingApproveComponent {
	@ViewChild('billingTable') table: any;

	organization: string;

	billDetails: Observable<any[]>;

	// datatable
	columns = [
		{ prop: 'org.org_name', name: 'Company', width: 130 },
		{ prop: 'start', name: 'Start date', width: 110 },
		{ prop: 'end', name: 'End date', width: 110 },
		{ prop: 'total', name: 'Amount' },
	];

	rows = [];
	temp = [];
	orig_rows = [];
	loadingIndicator = true;
	reorderable = true;
	expanded: any = {};
	timeout: any;

	successed = false;
	inProgress = false;
	errorMessage: string;
	id: string;
	date: string;
	name = '';
	bill_data: any[];

	constructor(
		public router: Router,
		private billingService: BillingService,
		private route: ActivatedRoute,
		private userService: UserService,
	) {
		this.userService.user$.pipe(filter(Boolean)).subscribe(() => {
			if (this.userService.organizationId) {
				this.organization = this.userService.organizationId;
			}
		});

		const t = this.route.params.subscribe((params) => {
			if (params['id']) {
				this.id = params['id'];
			}
			if (params['date']) {
				this.date = params['date'];
			}
		});

		this.billDetails = this.billingService.getBillDetails(this.id, this.date);

		this.billDetails.subscribe(
			(response) => {
				this.name = response['name'];
				this.bill_data = response['items'];

				this.rows = this.bill_data;
				this.orig_rows = this.bill_data;
				this.temp = [...this.rows];

				setTimeout(() => {
					this.loadingIndicator = false;
				}, 1000);
			},
			(err: HttpErrorResponse) => {
				console.log(err.message);
				this.loadingIndicator = false;
				this.rows = [];
				this.orig_rows = [];
				this.temp = [];
				return;
			},
		);
	}

	approveBill() {
		const approveBill = this.billingService.approveBill(this.name, this.bill_data);
		this.inProgress = true;
		approveBill.subscribe(
			(response) => {
				if (response['message'] === 'Success') {
					this.successed = true;
					this.inProgress = false;
				} else {
					this.successed = false;
					this.inProgress = false;
					this.errorMessage = response['message'];
				}
			},
			(err: HttpErrorResponse) => {
				console.log(err.message);
				this.successed = false;
				this.inProgress = false;
				this.errorMessage = err.message;
			},
		);
	}
}
